import { getDownloadURL, ref } from "firebase/storage";
import { storage } from "../backend/firebaseconfig";

/**
 * Attempts to fetch a logo URL from Firebase Storage.
 * Tries <brandName>.jpg first, then <brandName>.png.
 * Returns an empty string if neither file exists.
 *
 * @param {string} brandName
 * @returns {Promise<string>}
 */
export async function fetchLogoUrl(brandName) {
  if (!brandName) return "";

  const name = brandName.trim();
  if (!name) return "";

  for (const ext of ["jpg", "png"]) {
    try {
      const url = await getDownloadURL(ref(storage, `Logos/${name}.${ext}`));
      return url;
    } catch {
      // try next extension
    }
  }

  return "";
}
